import { constants as LOG_CONSTANTS } from '@saucelabs/sl-component-log';

import { APP_FILTER_NAME as APP } from './constants';

const { LEVELS, LEVELS_BY_SEVERITY } = LOG_CONSTANTS;

export const logFilesOnly = (assets) => (
  Object.entries(assets)
    .filter(([key, value]) => (
      !['video', 'video.mp4', 'screenshots'].includes(key) && value
    ))
);

const filterLogFilesByAllowlist = (assets) => (
  assets.filter((asset) => ['.zip', '.log', '.json', '.xml', '.txt', '.yml', '.har'].some((ext) => asset.value.endsWith(ext)))
);

// Exclude non-log files from the list of assets.
const filterLogFilesByDenylist = (assets) => (
  assets.filter((asset) => ['.png'].every((ext) => !asset.value.endsWith(ext)))
);

export const logFilesListForDropdown = ({ assets, isAppium, enforceExtension }) => {
  let mappedFiles = logFilesOnly(assets).map(([, value]) => {
    if (isAppium && value === 'selenium-server.log') {
      return { value, text: 'appium-server.log' };
    }
    return ({ value, text: value });
  });

  mappedFiles = filterLogFilesByDenylist(mappedFiles);

  if (enforceExtension) {
    return filterLogFilesByAllowlist(mappedFiles);
  }
  return mappedFiles;
};

const filterByLogLevel = (lines, logLevel) => {
  const visibleLogLevels = LEVELS_BY_SEVERITY.slice(LEVELS_BY_SEVERITY.indexOf(LEVELS[logLevel]));
  return lines.filter((line) => visibleLogLevels.includes(line.level));
};

const filterByPhrase = (lines, filter) => {
  if (!filter.phrase) return lines;

  let matchFunction;
  if (filter.regex) {
    const regex = new RegExp(filter.phrase, filter.ignoreCase ? 'i' : '');
    matchFunction = (line) => line.search(regex) >= 0;
  } else if (filter.ignoreCase) {
    const phrase = filter.phrase.toLowerCase();
    matchFunction = (line) => line.toLowerCase().includes(phrase);
  } else {
    matchFunction = (line) => line.includes(filter.phrase);
  }

  return lines.filter((line) => matchFunction(line.message) !== filter.invert);
};

const filterByProcessId = (lines, processIds) => {
  if (processIds.length === 0) {
    return [];
  }

  return lines.filter((line) => line.processId && processIds.indexOf(line.processId) >= 0);
};

export const getDisplayedLines = (lines, logLevel, filters, processIds, appFilter) => {
  if (appFilter === APP && lines.length > 0) {
    return filterByProcessId(filterByPhrase(
      filterByLogLevel(lines, logLevel),
      filters,
    ), processIds);
  }

  return filterByPhrase(
    filterByLogLevel(lines, logLevel),
    filters,
  );
};

export const findProcessIds = (lines) => (
  lines.map((line) => {
    if (!line.processId) {
      return null;
    }
    const match = line.message.match(/RDCIdentifier: \[(.*)\]/);
    return match ? line.processId : null;
  }).filter((line) => line !== null)
);

export default { logFilesOnly };
